const { server_ip }= require('../config');

export async function insertNewQuestionnaire(token,name){
    try {
        const response= await fetch(`${server_ip}/api/questionnaires`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                name
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function fetchQuestionnaires(token,filter,options,project){
    try {
        const response= await fetch(`${server_ip}/api/questionnaires/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options,
                ...project?{project}:{}
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}


export async function fetchQuestionnaireById(token,id,){
    try {
        const response= await fetch(`${server_ip}/api/questionnaires/${id}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function updateQuestionnaireById(token,id,data){
    try {
        const response= await fetch(`${server_ip}/api/questionnaires/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function deleteQuestionnaireById(token,id){
    try {
        const response= await fetch(`${server_ip}/api/questionnaires/${id}`,{
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}